import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const blockerStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 99999,
  backgroundColor: 'rgba(0, 0, 0, 0.85)',
  backdropFilter: 'blur(8px)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#fff',
  textAlign: 'center',
  padding: '24px',
};

const iconStyle: React.CSSProperties = {
  fontSize: '56px',
  marginBottom: '20px',
};

const buttonStyle: React.CSSProperties = {
  marginTop: '32px',
  padding: '12px 32px',
  fontSize: '16px',
  fontWeight: 'bold',
  color: '#fff',
  backgroundColor: '#00D084',
  border: 'none',
  borderRadius: '50px',
  cursor: 'pointer',
  boxShadow: '0 4px 12px rgba(0, 208, 132, 0.3)',
  transition: 'transform 0.2s',
};

interface OfflineBannerProps {
  isOnline: boolean;
}

const OfflineBanner: React.FC<OfflineBannerProps> = ({ isOnline }) => {
  const { t } = useTranslation();
  const [isChecking, setIsChecking] = useState(false);

  if (isOnline) return null;

  const handleReconnect = async () => {
    setIsChecking(true);
    try {
      const response = await fetch(window.location.origin + '/favicon.ico', {
        method: 'HEAD',
        cache: 'no-cache'
      });
      if (response.ok || response.status === 200) {
        window.dispatchEvent(new Event('online'));
      }
    } catch (e) {
      // Still offline
    }
    setTimeout(() => setIsChecking(false), 500);
  };

  return (
    <div style={blockerStyle}>
      <div style={iconStyle}>📡</div>
      <h2 style={{ fontWeight: 'bold', marginBottom: '12px' }}>{t('offline.title')}</h2>
      <p style={{ fontSize: '16px', maxWidth: '400px', color: '#e0e0e0' }}>
        {t('offline.desc')}
      </p>
      <button
        style={{ ...buttonStyle, opacity: isChecking ? 0.7 : 1 }}
        onClick={handleReconnect}
        disabled={isChecking}
        onMouseOver={(e) => !isChecking && (e.currentTarget.style.transform = 'scale(1.05)')}
        onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
      >
        {isChecking ? t('offline.checking') : t('offline.reconnect')}
      </button>
    </div>
  );
};

export default OfflineBanner;
